export const PDF_EXPORT_QUERY_PARAM_EXPORT_MODE = 'exportMode';
export const PDF_EXPORT_QUERY_PARAM_EXPORT_TARGET = 'exportTarget';
export const PDF_EXPORT_QUERY_PARAM_EXPORT_TAB = 'exportTab';
export const PDF_EXPORT_QUERY_PARAM_EXPORT_DESCRIPTION_PAGE = 'exportDescriptionPage';

// Relay contract for notes/documents that must be rendered as PDF text (not
// captured as part of the screenshot). The owning page mounts a hidden relay
// (ExportWidgetRelay) that fetches the page's client notes + document
// references from the API and writes them into a hidden JSON node. The capture
// pipeline reads this node and hands the data to PdfExporter to draw as text.
//
//  - `document.body[data-export-widget-status-<lowercased-target>]` is set to
//    `"loading"` as soon as the relay mounts and `"ready"` once notes/docs
//    have settled. Its presence tells the capture pipeline a relay exists on
//    this page and it should wait for the data before capturing.
//  - The `[data-export-widget="<target>"]` node holds the serialized JSON
//    payload (`ExportFooterData`).
export const exportWidgetStatusAttr = (target: string) => `data-export-widget-status-${target.toLowerCase()}`;
export const EXPORT_WIDGET_NODE_ATTR = 'data-export-widget';
export const exportWidgetNodeSelector = (target: string) => `[${EXPORT_WIDGET_NODE_ATTR}="${target}"]`;
